import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/purchase-requests")({
  beforeLoad: () => { throw redirect({ to: "/indents" }); },
});
